/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Per_Unit_MinuteInputs */

const en_admin_resource_form_per_unit_minute = /** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per hour`)
};

const de_admin_resource_form_per_unit_minute = /** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Stunde`)
};

const es_admin_resource_form_per_unit_minute = /** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por hora`)
};

const fr_admin_resource_form_per_unit_minute = /** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par heure`)
};

/** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */
const it_admin_resource_form_per_unit_minute = en_admin_resource_form_per_unit_minute;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */
const pt_br2_admin_resource_form_per_unit_minute = en_admin_resource_form_per_unit_minute;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */
const pl_admin_resource_form_per_unit_minute = en_admin_resource_form_per_unit_minute;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */
const hu_admin_resource_form_per_unit_minute = en_admin_resource_form_per_unit_minute;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_MinuteInputs) => LocalizedString} */
const ro_admin_resource_form_per_unit_minute = en_admin_resource_form_per_unit_minute;

/**
* | output |
* | --- |
* | "per hour" |
*
* @param {Admin_Resource_Form_Per_Unit_MinuteInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_per_unit_minute = /** @type {((inputs?: Admin_Resource_Form_Per_Unit_MinuteInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Per_Unit_MinuteInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_per_unit_minute(inputs)
	if (locale === "de") return de_admin_resource_form_per_unit_minute(inputs)
	if (locale === "es") return es_admin_resource_form_per_unit_minute(inputs)
	if (locale === "fr") return fr_admin_resource_form_per_unit_minute(inputs)
	if (locale === "it") return it_admin_resource_form_per_unit_minute(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_per_unit_minute(inputs)
	if (locale === "pl") return pl_admin_resource_form_per_unit_minute(inputs)
	if (locale === "hu") return hu_admin_resource_form_per_unit_minute(inputs)
	return ro_admin_resource_form_per_unit_minute(inputs)
});
export { admin_resource_form_per_unit_minute as "admin.resource_form.per_unit_minute" }